import { useSyncExternalStore } from "react";
import type { ThemeMode } from "../stores/theme";

function subscribeTheme(onStoreChange: () => void) {
  const observer = new MutationObserver(onStoreChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
  return () => observer.disconnect();
}

function readTheme(): ThemeMode {
  return document.documentElement.dataset.theme === "light" ? "light" : "dark";
}

export function brandLogoSrc(theme: ThemeMode = readTheme()): string {
  return theme === "light" ? "/logo-full.png" : "/logo-wordmark.png";
}

export function BrandLogo({
  className,
  alt = "Mr Gaole",
}: {
  className?: string;
  alt?: string;
}) {
  const theme = useSyncExternalStore(subscribeTheme, readTheme, () => "dark" as ThemeMode);
  return <img src={brandLogoSrc(theme)} alt={alt} className={className} />;
}
